module.exports = __webpack_public_path__ + "img/cross.a4bc97a.svg";